exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".message-slider {\n  width: 100%;\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 1.5em;\n  font-weight: 600;\n  line-height: 2.2;\n  color: #f4f4f4;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.message-slider div {\n  display: inline-block;\n  padding-left: 100%;\n  animation: scroll 30s linear infinite; }\n\n@keyframes scroll {\n  0% {\n    transform: translate(0, 0); }\n  100% {\n    transform: translate(-100%, 0); } }\n\n.message-slider.black {\n  background: #231f20; }\n\n.message-slider.yellow {\n  background: #EDBD3E; }\n\n.message-slider.orange {\n  background: #ed811c; }\n\n.message-slider.red {\n  background: #ef3d42; }\n\n.message-slider.green {\n  background: #559a73; }\n\n.message-slider.purple {\n  background: #8b3187; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/MessageSlider/MessageSlider.scss
// module id = 1467
// module chunks = 0